import SelectCardApi from "@/api/cardBind";
import { Component, Vue } from "vue-property-decorator";

const style = require("./index.module.scss");

interface UserInfoVo {
  phone: string;
  userName: string;
  idCardNo: string;
}
@Component({ name: "YXHContractCheckSign" })
export default class YXHContractCheckSign extends Vue {
  private userInfoMation: UserInfoVo = {
    phone: "",
    userName: "",
    idCardNo: "",
  };

  private async created() {
    const userInfo = await SelectCardApi.getUserInfomation();
    if (userInfo) {
      this.userInfoMation.userName = userInfo.userName;
      this.userInfoMation.idCardNo = userInfo.idCardNo;
    }
  }

  // 年月日
  private renderDate() {
    const d = new Date();
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
  }

  private render() {
    return (
      <div class={style.YXHContractCheckSign}>
        <p class={style.title}>
          <strong>电子签名数字证书用户申请确认函</strong>
        </p>
        <p>重庆程远未来电子商务服务有限公司：</p>
        <p>
          <strong>
            &nbsp;&nbsp;
            尊敬的客户：为了维护您的利益，在您签署本授权书之前，仔细阅读本授权书各条款（特别是黑体字条款），关注您在授权书中的权利、义务。若有任何疑问，可向经办人员咨询。
          </strong>
        </p>
        <p>
          本人（姓名：{this.userInfoMation.userName}
          ，证件类型：身份证，证件号码：{this.userInfoMation.idCardNo}{" "}
          ）已收到贵公司于{this.renderDate()}
          发送的《电子签名数字证书用户使用须知》（下称“该须知”、“须知”）。本人已阅读、充分理解和认可该须知内容，并做如下承诺和确认：
        </p>
        <p>
          &nbsp;二、本人数字证书信息如在数字证书有效期限内变更的，本人承诺将及时书面告知贵公司，并终止使用该数字证书。
        </p>
        <p>
          &nbsp;三、本人同意贵公司向有关部门、授权的注册机构和个人核实本人的信息。贵公司有权合法收集、处理、传递及应用本人的资料，并请按照国家有关规定及须知的约定对本人资料保密。
        </p>
        <p>
          &nbsp;四、本人承诺独立享有数字证书的使用权；因使用数字证书产生的义务、责任由本人自行承担。
        </p>
        <p>
          &nbsp;五、数字证书有效期限届满，需要继续使用的，本人承诺通过本人依赖方平台与贵公司办理数字证书更新手续。
        </p>
        <p>
          &nbsp;六、本人同意贵公司依照须知规定的情形撤销本人的数字证书并不承担任何责任。由此给贵公司造成损失的，本人承诺向贵公司承担赔偿责任。
        </p>
        <p>
          &nbsp;七、本人同意因地震、洪水自然灾害、电力故障及通讯故障等不可抗力因素遭受损失的，贵公司不承担任何责任。
        </p>
        <p>
          &nbsp;八、若由于贵公司原因给本人造成损失的，本人将依照须知的规定，在该情形出现之日起两年内向贵公司提出赔付申请并提交相关材料；逾期视为本人放弃请求贵公司赔付的权利。
        </p>
        <p>
          &nbsp;九、本人同意贵公司有权单方面通过本人依赖方平台对须知内容做出非实质性变更；如做出实质性变更，本人将在合理期限内向贵公司提出异议并与贵公司进行积极协商以达成一致。
        </p>
        <p>
          &nbsp;十、本人同意，因数字证书申请、使用、服务等相关事宜与贵公司产生争议且协商不成的，贵公司与本人均同意按照本人最终使用本人在贵公司申请的电子签名签署的协议中的争议解决条款确定管辖权归属。
        </p>
        <p>
          &nbsp;十一、本人认可贵公司保存在本人依赖方平台上的通过盖章方式确认的须知之法律效力；本人在依赖方平台通过包括但不限于点击、勾选、手写签名等方式签署本确认函的行为，即表示本人同意接受该须知的全部内容，本人与贵公司之间的数字证书服务合同成立并生效，贵公司与本人签署、确认方式的不同不影响合同的法律效力。本人将依照该须知和本确认函的内容行使权利和履行义务，并在本人依赖方平台上使用贵公司为本人生成的数字证书签署相关合同和文件。
        </p>
        <p class={style.idCard}>签署日期：{this.renderDate()}</p>
      </div>
    );
  }
}
